import angular from 'angular';

import EventPhonePreviewComponent from './event-phone-preview.component';

const EventPhonePreview = angular
    .module('control-room.event.components.event-phone-preview', [])
    .component('crEventPhonePreview', EventPhonePreviewComponent);

export default EventPhonePreview;
